var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('home-carousel',{attrs:{"slides":_vm.slides}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }